"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.function.name");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _loading = require("@/mixins/loading/loading");

var _lastMileDelivery = require("@/mixins/last-mile-delivery/last-mile-delivery");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDPlanHeaderComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDPlanHeaderComponent, _Mixins);

  var _super = _createSuper(LMDPlanHeaderComponent);

  function LMDPlanHeaderComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDPlanHeaderComponent);
    _this = _super.apply(this, arguments);
    _this.oldPlanDate = null;
    _this.selectedPlanId = null;
    return _this;
  }

  (0, _createClass2.default)(LMDPlanHeaderComponent, [{
    key: "on$PlanDateChanges",
    value: function on$PlanDateChanges(newVal, oldVal) {
      this.oldPlanDate = oldVal;
      this.selectedPlanId = null;
    }
  }, {
    key: "onSelectedTruckChanges",
    value: function onSelectedTruckChanges(newVal) {
      if (this.helper.isUndefined(newVal)) {
        this.selectedPlanId = null;
      } else {
        var truck = this.getTruckInPlan(this.$selectedTruck);

        if (this.helper.isUndefined(truck)) {
          this.selectedPlanId = 'newPlanId';
        } else {
          this.selectedPlanId = null;
        }
      }
    }
  }, {
    key: "isAssignToTruckDisabled",
    get: function get() {
      return this.$selectedOrders.length === 0 || this.$selectedTruck === null || this.selectedPlanId === null;
    }
  }, {
    key: "getAssignTruckDisabledDetails",
    get: function get() {
      var reason = {
        reason1: false,
        reason2: false,
        reason3: false
      };

      if (this.selectedPlanId === null) {
        reason.reason1 = true;
      }

      if (this.$selectedOrders.length === 0) {
        reason.reason2 = true;
      }

      if (this.$selectedTruck === null) {
        reason.reason3 = true;
      }

      return reason;
    }
  }, {
    key: "areRoutesInTruckMultiplePlanner",
    get: function get() {
      if (!this.$plan || !this.$plan.trucks || !this.currPlanTruck) {
        return false;
      }

      var uniqUsers = this.helper.uniq(this.currPlanTruck['routes'].map(function (r) {
        return r['user'];
      }));

      if (this.helper.isUndefined(uniqUsers[0])) {
        return false;
      }

      return uniqUsers.length > 1 ? true : uniqUsers[0] !== this.$userInformation.user.name;
    }
  }, {
    key: "areRoutesInTruckCompleted",
    get: function get() {
      if (!this.$plan || !this.$plan.trucks || !this.currPlanTruck) {
        return false;
      }

      return this.currPlanTruck['routes'].some(function (route) {
        if (route.status.toUpperCase() === 'COMPLETED') {
          return true;
        }
      });
    }
  }, {
    key: "checkIfTruckHasRoutes",
    get: function get() {
      var _this2 = this;

      if (this.$selectedTruck) {
        var selectedOrderId = this.helper.get(this.helper.find(this.$plan.trucks, function (truck) {
          return truck['truckId'] === _this2.$selectedTruck;
        }), 'orderId', []);
        return selectedOrderId.length >= 1;
      } else {
        return false;
      }
    }
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "handlePlanDateChanges",
    value: function () {
      var _handlePlanDateChanges = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.$anyChanges) {
                  _context2.next = 5;
                  break;
                }

                message = this.$i18n.t('planning.messages.unsavedChanges');

                _elementUi.MessageBox.confirm(message, 'Warning', {
                  confirmButtonText: this.$i18n.t('pickColumns.confirm'),
                  cancelButtonText: this.$i18n.t('pickColumns.cancel'),
                  type: 'warning',
                  center: true
                }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _this3.oldPlanDate = null;
                          _this3.$anyChanges = false;
                          _context.next = 4;
                          return _this3.refreshPlan();

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }))).catch(function () {
                  _this3.$planDate = _this3.oldPlanDate;
                });

                _context2.next = 7;
                break;

              case 5:
                _context2.next = 7;
                return this.refreshPlan();

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handlePlanDateChanges() {
        return _handlePlanDateChanges.apply(this, arguments);
      }

      return handlePlanDateChanges;
    }()
  }, {
    key: "refreshPlan",
    value: function () {
      var _refreshPlan = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.$truckLoading = true;
                _context3.next = 3;
                return this.$resetPlan();

              case 3:
                _context3.next = 5;
                return this.$initPlan();

              case 5:
                if (!this.isAutoAssign) {
                  _context3.next = 11;
                  break;
                }

                if (!this.$selectedLocation) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 9;
                return this.$getUnassignedOrders();

              case 9:
                _context3.next = 13;
                break;

              case 11:
                _context3.next = 13;
                return this.$getUnassignedOrders();

              case 13:
                this.$truckLoading = false;

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function refreshPlan() {
        return _refreshPlan.apply(this, arguments);
      }

      return refreshPlan;
    }()
  }, {
    key: "refreshBrowser",
    value: function refreshBrowser() {
      location.reload();
    }
  }, {
    key: "assignToTruck",
    value: function assignToTruck() {
      this.$emit('onManualAssignTruck', this.selectedPlanId);

      var p = _objectSpread(_objectSpread({}, this.$pagination), {}, {
        currentPage: 1
      });

      this.$setPagination(p);
      this.selectedPlanId = null;
    }
  }, {
    key: "autoAssignToTruck",
    value: function autoAssignToTruck() {
      this.$emit('onAutoAssignTruck');
    }
  }, {
    key: "confirmDelete",
    value: function () {
      var _confirmDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this4 = this;

        var message;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                message = this.$i18n.t('planning.messages.deleteRoutesTruckConfirmation');

                _elementUi.MessageBox.confirm(message, 'Warning', {
                  confirmButtonText: this.$i18n.t('pickColumns.confirm'),
                  cancelButtonText: this.$i18n.t('pickColumns.cancel'),
                  type: 'warning',
                  center: true
                }).then(function () {
                  var bool = _this4.isAutoAssign;

                  _this4.deleteRoutesInTruck(bool);
                }).catch(function (action) {});

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function confirmDelete() {
        return _confirmDelete.apply(this, arguments);
      }

      return confirmDelete;
    }()
  }, {
    key: "handleSelectedTruckChanges",
    value: function handleSelectedTruckChanges(truckId) {
      // Socket for global trucks
      this.socketAPI.updateLMDGlobalSelectedTrucks({
        userEmail: this.$userInformation.user.name,
        socketId: this.$socketId,
        truckId: truckId ? [truckId] : []
      });
    }
  }]);
  return LMDPlanHeaderComponent;
}((0, _vuePropertyDecorator.Mixins)(_loading.LoadingMixin, _lastMileDelivery.LastMileDeliveryMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], LMDPlanHeaderComponent.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: 'manual'
})], LMDPlanHeaderComponent.prototype, "type", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], LMDPlanHeaderComponent.prototype, "isAutoAssign", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$planDate')], LMDPlanHeaderComponent.prototype, "on$PlanDateChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$selectedTruck')], LMDPlanHeaderComponent.prototype, "onSelectedTruckChanges", null);
LMDPlanHeaderComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDPlanHeaderComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-date-picker': _elementUi.DatePicker,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-button': _elementUi.Button,
    'el-tooltip': _elementUi.Tooltip,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-input': _elementUi.Input
  }
})], LMDPlanHeaderComponent);
var _default = LMDPlanHeaderComponent;
exports.default = _default;